import type { SlideDomainEnum, SortOrder } from "@/generated/graphql";

/**
 * The largest page the API will serve — `findByLessonId` rejects anything above it outright, so this
 * is a ceiling, not a preference, and it must not drift above the server's own MAX_SLIDES_PER_PAGE.
 *
 * Slides are read a whole lesson at a time (see useSlidesByLessonId), so this asks for the maximum:
 * a real lesson then arrives in ONE request. A longer one still pages, and the hook pulls the rest
 * without the reader doing anything.
 */
export const SLIDES_PAGE_SIZE = 2000;

export interface SlidesByLessonIdOptions {
  lessonId: string;
  searchText?: string | null | undefined;
  sortBy?: SortOrder | null | undefined;
  isTrash?: boolean | null;
  skip?: boolean;
  slideType?: string | null | undefined;
  domain?: SlideDomainEnum | null | undefined;
  knowledgeArea?: string | null | undefined;
  isHidden?: boolean | null | undefined;
  isCompleted?: boolean | null | undefined;
}

export const getSlidesByLessonIdVars = ({
  lessonId,
  searchText,
  sortBy,
  isTrash = false,
  slideType,
  domain,
  knowledgeArea,
  isHidden,
  isCompleted,
}: SlidesByLessonIdOptions) => {
  return {
    lessonId,
    limit: SLIDES_PAGE_SIZE,
    offset: 0,
    searchText: searchText || null,
    sortBy,
    isTrash,
    type: slideType ?? null,
    domain: domain ?? null,
    knowledgeArea: knowledgeArea ?? null,
    isHidden: isHidden ?? null,
    isCompleted: isCompleted ?? null,
  };
};
